import Phonebook from '../../components/Phonebook';

const PhonebookPage = () => {
  return (
    <>
      <Phonebook />
    </>
  );
};

export default PhonebookPage;
